import { ViewDetails } from '../../models/view-details.model';
import { RequestsTypesConstants } from '../requests-side-menu.constants';
import { TablePropertiesConstants } from '../table-properties.constant';

export class RequesterConstants {
    public static INPROGRESS_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.INPROGRESS_REQUESTS,
        tableColumn: TablePropertiesConstants.REQUESTER_TABLE_COLUMNS_INPROGRESS,
        tableWithSelection: false
    };

    public static COMPLETED_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.COMPLETED_REQUESTS,
        tableColumn: TablePropertiesConstants.REQUESTER_TABLE_COLUMNS,
        tableWithSelection: false
    };
}
